(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["canfish-banner-carousel"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('cf-reference-banners')){
customElements.define('cf-reference-banners',class extends HTMLElement{
 async connectedCallback(){
  if(this.abort)return;
  this.abort=new AbortController();const signal=this.abort.signal;
  this.row=this.querySelector('.hdt-banner-row');
  if(!this.row||this.dataset.enabled!=='true')return;
  this.query=this.querySelector('.swiper-wrapper');
  const mq=matchMedia('(min-width:768px)');this.mq=mq;
  this.sync=()=>{
   if(!this.isConnected||signal.aborted)return;
   const enabled=(mq.matches?this.dataset.desktop:this.dataset.mobile)==='true';
   if(!enabled){
    this.instance?.destroy(true,true);this.instance=null;
    this.row.classList.add('cf-carousel-off');
    this.row.classList.toggle('hdt-scroll-snap',!mq.matches&&this.dataset.snap==='true');
    return;
   }
   this.row.classList.remove('cf-carousel-off','hdt-scroll-snap');
   if(!window.Swiper||this.instance)return;
   Array.from(this.query.children).forEach(el=>el.classList.add('swiper-slide'));
   this.instance=new Swiper(this.row,{
    slidesPerView:Number(this.dataset.mb),spaceBetween:Number(this.dataset.gap),grabCursor:true,watchOverflow:true,
    observer:false,observeParents:false,resizeObserver:true,
    breakpoints:{768:{slidesPerView:Number(this.dataset.tb)},1150:{slidesPerView:Number(this.dataset.dk)}},
    pagination:this.dataset.pagination==='true'?{el:this.querySelector('.hdt-banners-swiper-pag'),clickable:true}:undefined
   });
  };
  mq.addEventListener('change',this.sync,{signal});
  document.addEventListener('shopify:block:select',e=>{
   if(!this.instance)return;
   const i=Array.from(this.query.children).findIndex(el=>el===e.target||el.contains(e.target));
   if(i>=0)this.instance.slideTo(i,0);
  },{signal});
  this.sync();
  if(!window.Swiper){
   window.cfBannerSwiperPromise=window.cfBannerSwiperPromise||new Promise((resolve,reject)=>{
    const script=document.createElement('script');script.src='https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js';
    script.onload=resolve;script.onerror=()=>{window.cfBannerSwiperPromise=null;reject(new Error('Swiper unavailable'));};document.head.append(script);
   });
   try{await window.cfBannerSwiperPromise;}catch(e){if(!signal.aborted)this.row.classList.add('cf-carousel-off');return;}
  }
  this.sync();
 }
 disconnectedCallback(){this.abort?.abort();this.abort=null;this.instance?.destroy(true,true);this.instance=null;}
});
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["cf-price-button"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cf-price-subscribe')) customElements.define('cf-price-subscribe', class extends HTMLElement {
 connectedCallback() {
  this.controller?.abort();
  this.controller = new AbortController();
  this.addEventListener('click', event => {
   const button = event.target.closest('button');
   const formId = this.dataset.formId.trim();
   if (!button || button.disabled || !formId) return;
   window.omnisend = window.omnisend || [];
   window.omnisend.push(['openForm', formId]);
  }, {signal:this.controller.signal});
 }
 disconnectedCallback() { this.controller?.abort(); }
});

if (!customElements.get('cf-price-purchase')) customElements.define('cf-price-purchase', class extends HTMLElement {
 connectedCallback() {
  this.controller = new AbortController();
  this.addEventListener('click', event => {
   if (event.target.closest('[data-purchase]')) this.purchase();
  }, {signal:this.controller.signal});
 }
 disconnectedCallback() { this.controller?.abort(); }
 async purchase() {
  const button = this.querySelector('[data-purchase]');
  const error = this.querySelector('[data-error-message]');
  if (this.busy || button.disabled) return;
  error.hidden = true;
  let body = new FormData();
  try {
   if (this.dataset.source === 'current') {
    const form = Array.from(document.querySelectorAll('form.hdt-main-product-form')).find(form => (form.getAttribute('id') || '').endsWith('__main-product' + this.dataset.product));
    if (!form || !form.reportValidity()) throw new Error(this.dataset.error);
    const submit = form.querySelector('button[name="add"]');
    if (!submit || submit.disabled) throw new Error(this.dataset.error);
    body = new FormData(form);
    body.delete('form_type'); body.delete('utf8'); body.delete('return_to'); body.delete('sections'); body.delete('sections_url');
   } else {
    body.set('id', this.querySelector('[data-variant]').value);
    body.set('quantity', this.querySelector('[data-quantity]').value);
   }
   if (!/^\d+$/.test(body.get('id') || '')) throw new Error(this.dataset.error);
   if (!body.has('quantity')) body.set('quantity','1');
   this.busy = true; button.disabled = true; button.setAttribute('aria-busy','true');
   const root = this.dataset.root.replace(/\/?$/, '/');
   const response = await fetch(root + 'cart/add.js', {method:'POST',headers:{Accept:'application/json'},body});
   const result = await response.json();
   if (!response.ok || result.status) throw new Error(result.description || this.dataset.error);
   window.location.assign(this.dataset.action === 'checkout' ? root + 'checkout' : this.dataset.cart);
  } catch (failure) {
   error.textContent = failure.message || this.dataset.error; error.hidden = false;
   this.busy = false; button.disabled = false; button.removeAttribute('aria-busy');
  }
 }
});
  } catch(e) { console.error(e); }
})();

})();
